import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { fuelTypeEnumOptions } from '~/shared/config/constants'
import { AutocompleteInput, NumericInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type SpecificationsProps = {
  showSkeleton?: boolean
  disabled?: boolean
}

export function Specifications({
  showSkeleton,
  disabled,
}: SpecificationsProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('technical specifications')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <AutocompleteInput
            label='form.fuel type'
            name='fuelType'
            placeholder='form.select fuel type'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            options={fuelTypeEnumOptions}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            label='form.estimated value'
            name='estimatedCost'
            placeholder='form.enter estimated value'
            skeletonShow={showSkeleton}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.engine number'
            name='engineNumber'
            placeholder='form.enter engine number'
            skeletonShow={showSkeleton}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            label='form.body number'
            name='bodyNumber'
            placeholder='form.enter body number'
            skeletonShow={showSkeleton}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={6}>
          <NumericInput
            label='form.engine volume'
            name='engineSize'
            placeholder='form.enter engine volume'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '' }}
          />
        </Grid>
        <Grid xs={6}>
          <NumericInput
            label='form.engine power'
            name='enginePower'
            placeholder='form.enter engine power'
            skeletonShow={showSkeleton}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '', suffix: ' л.с.' }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
